/**
 * Created by yangrui on 2021/4/14.
 */
'use strict';
const list2 = [
    {
        title: '发票类型',
        ref:'myForm_1',
        dataList: [
            {
                label: '发票类型',
                key:'nFplx',
                prop:['nFplx','nFplx'],
                value: '1',
                initIndex:'0',
                type: 'dropdown',
                // source: 'columns_nFplx'
                source: 'codeList_902001'
            },
        ]
    },

    {
        title: '基本信息',
        ref:'myForm_2',
        dataList: [
            {
                label: '保单号',
                key:'cDbh',
                prop:['cDbh','cDbh'],
                value: '',
                disabled:true,
            },
            {
                label: '抬头类型',
                key:'nTtlx',
                prop:['nTtlx','nTtlx'],
                value: '2',
                initIndex:'0',
                type: 'dropdown',
                // source: 'columns_nTtlx'
                source: 'codeList_902003'
            },
            {
                label: '抬头名称',
                key:'cTtmc',
                prop:['cTtmc','cTtmc'],
                value: '',
                type: 'dropdown',
                // source: 'options_taitou_name'
                source: 'codeList_ry'
            },
            {
                label: '证件(照)类型',
                key:'nZzlx',
                prop:['nZzlx','nZzlx'],
                value: '',
                type: 'dropdown',
                // source: 'options_zhengzao'
                source: 'codeList_zzlx'
                // source: 'codeList_check'
            },
            {
                label: '证件(照)号码',
                key:'cZzhm',
                prop:['cZzhm','cZzhm'],
                value: ''
            },

            {
                label: '纳税人名称',
                key:'cNsrmc',
                prop:['cNsrmc','cNsrmc_no'],
                required:[true,false],
                value: '',
                // maxlength:100
            },
            {
                label: '纳税人识别号',
                key:'cNsrsbh',
                prop:['cNsrsbh','cNsrsbh_no'],
                required:[true,false],
                value: '',
                // maxlength:100
            },
            {
                label: '电话',
                key:'cDh',
                prop:['cDh','cDh_no'],
                required:[true,false],
                value: '',
                // maxlength:20
            },
            {
                label: '开户银行名称',
                key:'cKhyhmc',
                prop:['cKhyhmc','cKhyhmc_no'],
                required:[true,false],
                value: '',
                // maxlength:100
            },

            {
                label: '开户银行账号',
                key:'cKhyhzh',
                prop:['cKhyhzh','cKhyhzh_no'],
                required:[true,false],
                value: '',
                // maxlength:50
            },
            {
                label: '地址',
                key: 'cDz',
                type: 'textarea',
                prop:['cDz','cDz_no'],
                required:[true,false],
                value: '',
                maxlength:100,
                rows:2
            },
        ]
    },

    {
        title: '寄送信息',
        ref:'myForm_3',
        dataList: [
            {
                label: '联系人',
                key:'cLxr',
                prop:['cLxr','cLxr'],
                value: '',
                // maxlength:100
            },
            {
                label: '联系人电话',
                key:'cLxrdh',
                prop:['cLxrdh','cLxrdh'],
                value: '',
                // maxlength:20
            },
            {
                label: '邮箱',
                key:'cYx',
                prop:['cYx','cYx'],
                value: '',
                required: [false, false],
                // maxlength:50
            },
            {
                label: '发票寄送地址',
                key:'nFsdz',
                type: 'textarea',
                prop:['nFsdz','nFsdz'],
                value: '',
                maxlength:100,
                rows:2
            },
        ]
    },
];

const list3 = [
    {
        title:'发票类型',
        dataList:[
            {
                name:'发票类型',
                key:'nFplx',
                value:''
            },
        ],
    },
    {
        title:'基本信息',
        dataList:[
            {
                name:'保单号',
                key:'cDbh',
                //value:'P110008001600000687'
            },
            {
                name:'抬头类型',
                key:'nTtlx',
                //value:'个人'
            },
            {
                name:'抬头名称',
                key:'cTtmc',
                //value:'王六'
            },
            {
                name:'证件(照)类型',
                key:'nZzlx',
                //value:'居民身份证'
            },
            {
                name:' 证件(照)号码',
                key:'cZzhm',
                //value:'421087198712283750'
            },

            {
                name:'纳税人名称',
                key:'cNsrmc',
                //value:'王六'
            },
            {
                name:' 纳税人识别号',
                key:'cNsrsbh',
                //value:'Q111111222222'
            },
            {
                name:'电话',
                key:'cDh',
                //value:'15911017679'
            },
            {
                name:'开户银行名称',
                key:'cKhyhmc',
                //value:'招商银行'
            },

            {
                name:'开户银行账号',
                key:'cKhyhzh',
                //value:'111122223333444455'
            },
            {
                name:'地址',
                key:'cDz',
                //value:'北京龙跃苑三区'
            },
        ],
    },

    {
        title:'寄送信息',
        dataList:[
            {
                name:'联系人',
                key:'cLxr',
                //value:'王六'
            },
            {
                name:'联系人电话',
                key:'cLxrdh',
                //value:'15911017611'
            },
            {
                name:'邮箱',
                key:'cYx',
                //value:'wangliu@126.com'
            },
            {
                name:'发票寄送地址',
                key:'nFsdz',
                //value:'北京龙跃苑四区'
            },
        ],
    },

    {
        title:'开票联系人信息',
        dataList:[
            {
                name:'开票人',
                key:'cKpr',
                //value:'王七'
            },
            {
                name:'开票人联系方式',
                key:'cKprlxfs',
                //value:'010-82428888'
            },
        ]
    }
];

const arrList2={
    columns_nFplx: [
        {
            value: "1",
            text: '增值税专用发票',
        }, {
            value: "2",
            text: '增值税普通发票',
        }
    ],
    columns_nTtlx: [
        {
            value: "1",
            text: '个人',
        }, {
            value: "2",
            text: '企业',
        }
    ]
};

let formData2={};
list2.map(item=>{
    item.dataList.map(item2=>{
        formData2[item2.key]=item2.value;
        // item2.prop.map(item3=>{
        //     if(!formData2.hasOwnProperty(item3)){
        //         formData2[item3]=item2.value;
        //     }
        // });
    });
})

export {
    list2,
    list3,
    formData2,
    arrList2,
}
